import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=156d84ce&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156d84ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156d84ce')) {
      api.createRecord('156d84ce', component.options)
    } else {
      api.reload('156d84ce', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=156d84ce&scoped=true&", function () {
      api.rerender('156d84ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xKd6ZSFNhSps/JS/comp/Accordion.vue"
export default component.exports